<template>
    <div class=embed :class="{ 'active' : active }">
        <transition name="fade" appear>
            <iframe :src="`${src}?${hash}`"></iframe>
        </transition>
    </div>
</template>
<script>
export default {
    name : 'Embed',
    props : {
        active : Boolean,
        src    : String ,
    },
}
</script>